/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExchangeTokenReq } from '../../models/exchange-token-req';

export interface ExchangeMetaTokenCustomer$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: ExchangeTokenReq
}

export function exchangeMetaTokenCustomer(http: HttpClient, rootUrl: string, params: ExchangeMetaTokenCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, exchangeMetaTokenCustomer.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

exchangeMetaTokenCustomer.PATH = '/v1/api/ui/meta-subscription/exchange-token';
